import { Children, cloneElement } from "react";

export default function DataTable({ headers, children, wrapStyle, tableStyle }) {
  const labelledRows = Children.map(children, (row) => {
    if (!row || row.type !== "tr") return row;

    const labelledCells = Children.map(row.props.children, (cell, index) => {
      if (!cell || cell.type !== "td") return cell;
      return cloneElement(cell, { "data-label": headers[index]?.trim() || "Actions" });
    });

    return cloneElement(row, undefined, labelledCells);
  });

  return (
    <div className="data-table-wrap" style={wrapStyle}>
      <table className="data-table" style={tableStyle}>
        <thead>
          <tr>{headers.map((header, index) => <th key={`${header}-${index}`}>{header}</th>)}</tr>
        </thead>
        <tbody>{labelledRows}</tbody>
      </table>
    </div>
  );
}